import React, { Component } from 'react';
import {Grid, Switch, InputLabel, Typography} from '@material-ui/core';

class Toggle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldValue: false,
        }
    }
    
    componentDidMount() {
        // console.log('Called cwm for input...');
        // console.log(this.props.editRecord);
        if (this.props.editRecord){
           let initVal =  this.props.editRecord[this.props.fieldMap.field];
           if (!initVal){initVal = false}
           this.setState({fieldValue:initVal});
           this.props.setField({field:this.props.fieldMap.field, value:initVal});
        }
    }
        
    handleChange = (e,checked) => {
        // console.log(date);
        // console.log(e);
        // console.log(checked);
        this.setState({fieldValue:checked});
        this.props.setField({field:this.props.fieldMap.field, value:checked});
    }

    render() {
        const spec = this.props.fieldMap; 
        const trueTag = spec.f_true_tag? spec.f_true_tag : 'True'      
        const falseTag = spec.f_false_tag? spec.f_false_tag : 'False'    
        // console.log(this.props.fieldMap);
        // console.log(trueTag);  
        return (
            <Grid item >
                <Grid container direction="row" justifyContent="flex-start" alignItems="baseline">
                <InputLabel htmlFor={spec.field}>
                    {this.state.fieldValue&&<div><b>{spec.headerName}</b></div>}
                    {!this.state.fieldValue&&<div>{spec.headerName}</div>}
                </InputLabel>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Typography><b>{this.state.fieldValue? trueTag:falseTag}</b></Typography>
                &nbsp;&nbsp;
                <Switch
                    id={spec.field}
                    checked={this.state.fieldValue}
                    disabled={this.props.disabled}
                    onChange={this.handleChange}
                    color='primary'
                />
                
                </Grid>
            </Grid>
        );
    }
 

}

export default Toggle;